<div id="container">
  <!-- <div class="smallScreenOnly"> -->
  <h1 class="sectionTitleHeader">{{ getQuestionGroupText() }}</h1>
  <!-- </div> -->
  <div class="content">
    <ng-template appQuestionList></ng-template>
  </div>
  <app-survey-navigation [marginBottom]="20"></app-survey-navigation>
</div>
